export const HIDE_RESULT = 'CLOSE_RESULT';
export const SHOW_RESULT = 'SHOW_RESULT';

export const hideResult = () => ({
    type: HIDE_RESULT,
});

export const showResult = (text, icon, success) => ({
    type: SHOW_RESULT,
    payload: {
        text,
        icon,
        success
    },
});